import styled from 'styled-components';
import media from 'styled-media-query';
import { generateMedia } from 'styled-media-query';
import LocalizedLink from '../LocalizedLink';
import { Link } from 'gatsby';

const customMedia = generateMedia({
  mobile: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  laptopXL: "2560px"
})

export const Navigation = styled.nav`

  display: flex;
  flex-direction: column;
  ${'' /* align-items: flex-start; */}
  ${'' /* padding-right: var(--space); */}
  max-width: 250px;
  
  }

  ${media.greaterThan('large')`
    max-width: 300px;
  `}

  ${media.greaterThan('huge')`
    max-width: 400px;
  `}
`;

export const NavigationLink = styled(LocalizedLink)`
  color: var(--gray-extra-light);
  font-family: var(--font-menu);
  font-size: 1.3rem;
  letter-spacing: 2px;
  text-decoration: none;
  text-transform: uppercase;
  position: relative;
  padding: 2.2rem var(--space-sm);
  
  ${customMedia.greaterThan('tablet')`
    font-size: 1.1rem;
    opacity: .8;
    letter-spacing: 2.5px;
    padding: 2rem var(--space-sm);    
  `}
  
  ${customMedia.greaterThan('laptop')`
    padding: 1.3rem var(--space-sm);

    &:last-child, &:nth-last-child(3) {
        margin-top: 4rem;
      }
  `}

  ${customMedia.greaterThan('laptopL')`
    font-size: 1.2rem;
    padding-right: 8rem;   
  `}

  &:before {
    ${media.greaterThan('medium')`
      content: '';
      display: inline-block;
      width: 0;
      height: 4px;
      background: var(--primary-color);
      position: absolute;
      left: -50px;
      top: 45%;
      opacity: 0;
      transition: .3s ease-in-out;
    `}

    ${customMedia.greaterThan('laptop')`
      left: -60px;
    `}

    ${customMedia.greaterThan('laptopL')`
      left: -80px;
    `}
  }  

  &:hover,
  &:focus,
  &:active {
    opacity: 1;
    ${media.greaterThan('medium')`

    `}

    &:before {
      opacity: 1;
      /* bottom: -10px; */
      width: 50px;
    }
  }

  &.current {
    color: var(--primary-color);
    opacity: 1;

    &:before {
      opacity: 1;
      width: 50px;
    }
  }
`;

// export const NavigationButton = styled(Link)`
//   background: var(--primary-color);
//   border-radius: 2px;
//   color: #fff;
//   display: inline-block;
//   padding: var(--space-sm) var(--space);
//   text-decoration: none;
//   font-weight: bold;
//   text-align: center;
//   ${media.greaterThan('medium')`
//     margin-left: var(--space-lg);
//   `}
// `;